import { getAccount, type GetAccountReturnType } from '../actions/getAccount';
import { watchAccount } from '../actions/watchAccount';
import { useContext } from '../context';
import { useSyncExternalStoreWithTracked } from './useSyncExternalStoreWithTracked';

export function useAccount(): GetAccountReturnType {
  const { config } = useContext();

  return useSyncExternalStoreWithTracked(
    (onChange) => watchAccount(config, { onChange }),
    () => getAccount(config)
  );
}
